var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-header-container",class:[_vm.skin(),{'mobile':this.$device.ios||this.$device.android }]},[_c('div',{staticClass:"logo"},[_c('Img',{attrs:{"url":this.logo.logo + '.png'}})],1),_c('Menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }